"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckTabsPanel = exports.CheckTabs = void 0;
var CheckTabs_1 = __importDefault(require("./CheckTabs"));
exports.CheckTabs = CheckTabs_1["default"];
var CheckTabsPanel_1 = __importDefault(require("./CheckTabsPanel"));
exports.CheckTabsPanel = CheckTabsPanel_1["default"];
exports["default"] = {
  CheckTabs: CheckTabs_1["default"],
  CheckTabsPanel: CheckTabsPanel_1["default"]
};